import { GCP_BACKEND_URL, Analysis } from '../../types';
import { fetchConversationMessages, ConversationMessage } from '../../utils/api';

export const getThumbnailUrl = (item: Analysis): string => {
  console.log('🔍 LOG 200: getThumbnailUrl called with item:', {
    id: item.id,
    session_id: item.session_id,
    thumbnail_url: item.thumbnail_url,
    chart_url: item.chart_url,
    map_url: item.map_url
  });

  if (item.thumbnail_url) {
    if (item.thumbnail_url.startsWith('http')) {
      console.log('🔍 LOG 201: Using thumbnail_url (http):', item.thumbnail_url);
      return item.thumbnail_url;
    }
    if (item.thumbnail_url.startsWith('/')) {
      const url = `${GCP_BACKEND_URL}${item.thumbnail_url}`;
      console.log('🔍 LOG 202: Using thumbnail_url (/):', url);
      return url;
    }
    console.log('🔍 LOG 203: Using thumbnail_url (as-is):', item.thumbnail_url);
    return item.thumbnail_url;
  }

  if (item.chart_url) {
    console.log('🔍 LOG 204: Using chart_url:', item.chart_url);
    return item.chart_url;
  }

  const url = `${GCP_BACKEND_URL}/results/${item.session_id}/preview`;
  console.log('🔍 LOG 205: Constructing from session_id:', url);
  return url;
};

export const getChartUrl = (item: Analysis): string => {
  console.log('🔍 LOG 210: getChartUrl called with item:', {
    id: item.id,
    session_id: item.session_id,
    chart_url: item.chart_url
  });
  if (item.chart_url) {
    console.log('🔍 LOG 211: Using chart_url:', item.chart_url);
    return item.chart_url;
  }
  const url = `${GCP_BACKEND_URL}/results/${item.session_id}/chart`;
  console.log('🔍 LOG 212: Constructing chart URL:', url);
  return url;
};

export const getMapUrl = (item: Analysis): string => {
  console.log('🔍 LOG 220: getMapUrl called with item:', {
    id: item.id,
    session_id: item.session_id,
    map_url: item.map_url
  });
  if (item.map_url) {
    console.log('🔍 LOG 221: Using map_url:', item.map_url);
    return item.map_url;
  }
  const url = `${GCP_BACKEND_URL}/results/${item.session_id}/map`;
  console.log('🔍 LOG 222: Constructing map URL:', url);
  return url;
};

export const getAnimationUrl = (item: Analysis): string => {
  if (item.animation_url) {
    return item.animation_url.startsWith('http') ? item.animation_url : `${GCP_BACKEND_URL}${item.animation_url}`;
  }
  return `${GCP_BACKEND_URL}/results/${item.session_id}/animation`;
};

export const getPreviewUrl = (item: Analysis): string => {
  return `${GCP_BACKEND_URL}/results/${item.session_id}/chart`;
};

export const loadConversationMessages = async (conversationId: string): Promise<ConversationMessage[]> => {
  try {
    const res = await fetchConversationMessages(conversationId);
    return res.messages || [];
  } catch (err) {
    console.error('Failed to load conversation messages:', err);
    return [];
  }
};
